import { Card, CardContent, Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Center from '../../components/layout/Center'

const EntityNotAccessibleError = () => (
  <Center sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
    <Card
      variant="outlined"
      sx={{
        maxWidth: 400,
        textAlign: 'center',
        padding: 2,
        boxShadow: 3,
      }}
    >
      <CardContent>
        <ErrorOutlineIcon color="error" sx={{ fontSize: 40 }} />
        <Typography variant="h6" sx={{ mt: 1, fontWeight: 'bold' }}>
          Entity Not Accessible
        </Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          The entity you are trying to view is either not accessible to you or does not exist.
        </Typography>
      </CardContent>
    </Card>
  </Center>
)

export default EntityNotAccessibleError
